// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1aJkq","detailsBorder":"styles_detailsBorder__1o9yO"};